import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-rich-content',
  templateUrl: './rich-content.component.html',
  styleUrls: ['./rich-content.component.scss'],
})
export class RichContentComponent {
  private _content: string;

  @Input() showParagraphMargin?: boolean;
  @Input() set content(value: string) {
    this._content = this.cleanHtmlContent(value);
  }

  get content(): string {
    return this._content;
  }

  private cleanHtmlContent(html: string): string {
    const parser: DOMParser = new DOMParser();
    const htmlDoc: Document = parser.parseFromString(
      `<div class="rich-content-wrapper_content">${html}</div>`,
      'text/html'
    );

    const titleElements: NodeListOf<Element> = htmlDoc.querySelectorAll('.advisory__content-title');

    titleElements.forEach((element) => {
      if (element.innerHTML.trim() === '&nbsp;') {
        element.remove();
      }
    });

    return htmlDoc.body.innerHTML;
  }
}
